import { z } from "zod";
import { SitePackageIdSchema } from "./site-package.js";
import { BusinessGraphContradictionResultV1Schema } from "./business-graph-contradiction.js";
export const ReadinessLevelSchema = z.enum([
    "NEEDS_BASICS",
    "ONE_PAGE_AVAILABLE",
    "THREE_PAGE_AVAILABLE",
    "FIVE_PAGE_AVAILABLE",
    "STRONG_PROFILE_LARGER_LATER",
]);
export const BusinessTypeSchema = z.enum([
    "contractor",
    "hvac",
    "plumbing",
    "landscaping",
    "general_contractor",
    "professional_service",
    "medical_or_wellness",
    "restaurant_or_cafe",
    "retail_or_showroom",
    "other",
]);
export const PrimaryEvidenceTypeSchema = z.enum([
    "license_or_certification",
    "before_after_photos",
    "project_portfolio",
    "emergency_availability",
    "service_area_coverage",
    "reviews_or_testimonials",
    "product_catalog",
    "menu_or_offers",
    "professional_credentials",
    "none_yet",
]);
export const BusinessProfileReadinessPolicyV1Schema = z
    .object({
    schemaVersion: z.literal("business-profile-readiness-policy.v1.0"),
    policyVersion: z.string().min(1),
    /** Internal thresholds — not exposed as user-facing percentages. */
    minServicesForThreePage: z.number().int().min(1).default(1),
    minServicesForFivePage: z.number().int().min(1).default(2),
    requireContactMethod: z.boolean().default(true),
    requireServiceArea: z.boolean().default(true),
    requirePrimaryService: z.boolean().default(true),
})
    .strict();
export const DEFAULT_BUSINESS_PROFILE_READINESS_POLICY = BusinessProfileReadinessPolicyV1Schema.parse({
    schemaVersion: "business-profile-readiness-policy.v1.0",
    policyVersion: "BusinessProfileReadinessPolicyV1",
    minServicesForThreePage: 1,
    minServicesForFivePage: 2,
    requireContactMethod: true,
    requireServiceArea: true,
    requirePrimaryService: true,
});
export const BusinessProfileReadinessV1Schema = z
    .object({
    schemaVersion: z.literal("business-profile-readiness.v1.0"),
    readinessLevel: ReadinessLevelSchema,
    availablePackages: z.array(SitePackageIdSchema),
    blockedPackages: z.array(SitePackageIdSchema),
    missingRequirements: z.array(z.string()),
    warnings: z.array(z.string()),
    hardBlockers: z.array(z.string()),
    policyVersion: z.string().min(1),
    evaluatedAt: z.string().datetime(),
    evaluatedFromBusinessGraphSnapshotHash: z.string(),
    confirmedFieldsOnly: z.literal(true),
    businessType: BusinessTypeSchema,
    primaryEvidenceType: PrimaryEvidenceTypeSchema,
    /** Gate 2 Phase 2 — computed contradiction status (BG-005). */
    contradictionResult: BusinessGraphContradictionResultV1Schema,
})
    .strict();
export const EligibilityBlockedResponseSchema = z
    .object({
    status: z.literal("ELIGIBILITY_BLOCKED"),
    requestedPackage: SitePackageIdSchema,
    currentReadinessLevel: ReadinessLevelSchema,
    availablePackages: z.array(SitePackageIdSchema),
    blockedPackages: z.array(SitePackageIdSchema),
    missingRequirements: z.array(z.string()),
    hardBlockers: z.array(z.string()),
    warnings: z.array(z.string()),
    policyVersion: z.string().min(1),
    contradictionResult: BusinessGraphContradictionResultV1Schema.optional(),
})
    .strict();
//# sourceMappingURL=business-profile-readiness.js.map